import React, { useState, useEffect } from 'react'

const getSchoolsAdministered = (callback) => {
  fetch('/api/v1/admins/my-schools',
    {
      method: 'GET',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
    })
    .then(response => response.json())
    .then(obj => {
      if (obj.error) {
        alert(I18N._("Failed to load schools") + ": " + JSON.stringify(obj))
      } else {
        callback(obj.schools)
      }
    })
    .catch(err => {
      console.error(err)
      alert(I18N._("Error requesting data from backend") + ": " + err)
    })
}

const SchoolCheckboxList = ({ schools, selectedSchoolIds, onToggle, onToggleAll }) => (
  <div className="school-selection-list-container">
    <div className="checkbox select-all">
      <label>
        <input
          type="checkbox"
          checked={schools.length > 0 && selectedSchoolIds.length === schools.length}
          onChange={onToggleAll}
          style={{ marginTop: "4px" }}
        />
        <span>
          {I18N._("Select all")}
        </span>
      </label>
    </div>
    <div className="school-selection-list vertical-spacing-bottom" style={{ height: "15rem", overflowY: "auto" }}>
      {schools.map((school) => (
        <div className="checkbox" key={school.id}>
          <label>
            <input
              type="checkbox"
              checked={selectedSchoolIds.includes(school.id)}
              onChange={() => onToggle(school.id)}
            />
            {school.name}
          </label>
        </div>
      ))}
    </div>
  </div>
)

/** Fetches the schools administered by the current user and lets them be picked
 * via checkboxes. Calls `onSubmit(selectedSchoolIds)` when the submit button is
 * clicked; the button is disabled while nothing is selected.
 */
export default ({ submitLabel, onSubmit }) => {
  const [schools, setSchools] = useState([])
  const [selectedSchoolIds, setSelectedSchoolIds] = useState([])

  useEffect(() => {
    getSchoolsAdministered(setSchools)
  }, [])

  const toggleSchool = (schoolId) => {
    setSelectedSchoolIds((prev) =>
      prev.includes(schoolId) ? prev.filter((id) => id !== schoolId) : [...prev, schoolId]
    )
  }

  const toggleAllSchools = () => {
    setSelectedSchoolIds((prev) =>
      prev.length === schools.length ? [] : schools.map((school) => school.id)
    )
  }

  const handleSubmit = (ev) => {
    ev.preventDefault()
    onSubmit(selectedSchoolIds)
  }

  return (
    <React.Fragment>
      <SchoolCheckboxList
        schools={schools}
        selectedSchoolIds={selectedSchoolIds}
        onToggle={toggleSchool}
        onToggleAll={toggleAllSchools}
      />
      <div className="button-group pull-right">
        <button
          className="btn btn-success"
          disabled={selectedSchoolIds.length === 0}
          onClick={handleSubmit}>
          {submitLabel}
        </button>
      </div>
    </React.Fragment>
  )
}
